<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true"
          >บันทึกข้อมูลเรียบร้อย !</v-alert
        >
        <v-alert type="success" class="alert" v-if="alert_tracking === true"
          >เปลี่ยนสถานะเรียบร้อย !</v-alert
        >
        <v-alert
          type="success"
          class="alert"
          v-if="alert_clear_reset_lot_success === true"
          >เคลียร์ล็อตสินค้าใหม่เรียบร้อย !</v-alert
        >
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="ma-4">
          <div class="pa-3 pt-7">
            <v-divider />
            <v-tabs
              grow
              show-arrows
              v-model="tab_menu"
              color="#8cc63e"
              v-if="loading_data === true"
            >
              <v-tab style="font-size: 18px" disabled
                >คำสั่งกำลังดำเนินการ</v-tab
              >
              <v-tab style="font-size: 18px" disabled>เสร็จสิ้น</v-tab>
            </v-tabs>
            <v-tabs grow show-arrows v-model="tab_menu" color="#8cc63e" v-else>
              <v-tab style="font-size: 18px">คำสั่งกำลังดำเนินการ</v-tab>
              <v-tab style="font-size: 18px">เสร็จสิ้น</v-tab>
            </v-tabs>
            <v-divider />
          </div>
          <div class="pa-3">
            <v-card-title>
              <v-text-field
                v-model="search"
                color="#86bc3a"
                append-icon="mdi-magnify"
                label="ค้นหา"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <div v-if="loading_data === true">
              <v-sheet
                :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
                class="pa-3"
              >
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-data-table
                :headers="headers"
                :items="data_list"
                mobile-breakpoint="0"
                hide-default-footer
                :search="search"
              >
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td>{{ dataDetail.item.order_code }}</td>
                    <td>{{ dataDetail.item.receipt_code || "-" }}</td>
                    <td>{{ dataDetail.item.name }}</td>
                    <td>
                      <div v-if="dataDetail.item.status === 0">
                        <div style="color: #8cc63e">
                          {{ format_price(dataDetail.item.total) }}
                        </div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 1">
                        <div style="color: #fdac39">
                          {{ format_price(dataDetail.item.total) }}
                        </div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 2">
                        <div style="color: #8cc63e">
                          {{ format_price(dataDetail.item.total) }}
                        </div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 3">
                        <div style="color: red">
                          {{ format_price(dataDetail.item.total) }}
                        </div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 4">
                        <div style="color: #fdac39">
                          {{ format_price(dataDetail.item.total) }}
                        </div>
                      </div>
                    </td>
                    <td>{{ dataDetail.item.created_at }}</td>
                    <td v-if="title_type === 0">
                      <div v-if="dataDetail.item.status === 0">
                        <div style="color: #8cc63e">คำสั่งซื้อใหม่</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 1">
                        <div style="color: #fdac39">ดำเนินการจัดสินค้า</div>
                      </div>
                      <div v-else-if="dataDetail.item.status === 4">
                        <!-- <div style="color: #fdac39">เสนอดีลใหม่</div> -->
                        <div style="color: #fdac39">ดำเนินการจัดสินค้า</div>
                      </div>
                    </td>
                    <td v-else>
                      <div
                        v-if="
                          dataDetail.item.status === 2 &&
                          dataDetail.item.delivery_type === 1
                        "
                      >
                        รับหน้าร้าน
                      </div>
                      <div
                        v-else-if="
                          dataDetail.item.status === 2 &&
                          dataDetail.item.delivery_type === 2
                        "
                        style="color: grey"
                      >
                        แทร็กกิ้ง : {{ dataDetail.item.track_number }}
                      </div>
                      <div v-else style="color: red">
                        ยกเลิก : {{ dataDetail.item.cancel_note }}
                      </div>
                    </td>
                    <td class="pa-3">
                      <div v-if="dataDetail.item.status === 0">
                        <v-btn
                          small
                          height="42"
                          class="grad-success-bg white--text mr-1 mb-1"
                          @click="get_detail(dataDetail.item.id)"
                          title="รายละเอียด"
                        >
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.status === 1">
                        <v-btn
                          small
                          height="42"
                          class="grad-success-bg white--text mr-1 mb-1"
                          @click="get_detail(dataDetail.item.id)"
                          title="รายละเอียด"
                        >
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          @click="
                            tracking_modal(
                              dataDetail.item.id,
                              dataDetail.item
                                .count_product_not_have_in_warehouse
                            )
                          "
                          height="42"
                          class="grad-warning-bg white--text mr-1 mb-1"
                          style="font-size: 18px"
                        >
                          ส่งแล้ว
                        </v-btn>
                        <v-btn
                          small
                          @click="clear_reset_lot_modal(dataDetail.item.id)"
                          height="42"
                          class="grad-cancel-bg white--text mr-1 mb-1"
                          title="รีเซ็ต"
                        >
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.status === 2">
                        <v-btn
                          small
                          height="42"
                          class="grad-success-bg white--text mr-1 mb-1"
                          @click="get_detail(dataDetail.item.id)"
                          title="รายละเอียด"
                        >
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          height="42"
                          class="grad-main-bg white--text mr-1 mb-1"
                          @click="openStockLogDialog(dataDetail.item.id)"
                          title="Log การอัพเดท stock"
                        >
                          <v-icon>mdi-file-document-outline</v-icon>
                          Log
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.status === 3">
                        <v-btn
                          small
                          height="42"
                          class="grad-success-bg white--text mr-1 mb-1"
                          @click="get_detail(dataDetail.item.id)"
                          title="รายละเอียด"
                        >
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                      </div>
                      <div v-else-if="dataDetail.item.status === 4">
                        <v-btn
                          small
                          height="42"
                          class="grad-success-bg white--text mr-1 mb-1"
                          @click="get_detail(dataDetail.item.id)"
                          title="รายละเอียด"
                        >
                          <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <!-- <v-btn v-if="dataDetail.item.delivery_type === 1" small @click="tracking_shop(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn v-else-if="dataDetail.item.delivery_type === 2" small @click="tracking_chiangmai(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn>
                        <v-btn v-else-if="dataDetail.item.delivery_type === 3" small @click="tracking_global(dataDetail.item.id,dataDetail.item.count_product_not_have_in_warehouse)" height="42" class="grad-warning-bg white--text mr-1 mb-1" title="ส่ง" style="font-size: 18px">
                          ส่งแล้ว
                        </v-btn> -->
                        <v-btn
                          small
                          @click="
                            tracking_modal(
                              dataDetail.item.id,
                              dataDetail.item
                                .count_product_not_have_in_warehouse
                            )
                          "
                          height="42"
                          class="grad-warning-bg white--text mr-1 mb-1"
                          style="font-size: 18px"
                        >
                          ส่งแล้ว
                        </v-btn>
                        <v-btn
                          small
                          @click="clear_reset_lot_modal(dataDetail.item.id)"
                          height="42"
                          class="grad-cancel-bg white--text mr-1 mb-1"
                          title="รีเซ็ต"
                        >
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </div>
                    </td>
                    <td class="pa-3">
                      <v-btn
                        small
                        height="42"
                        class="grad-main-bg white--text ml-1 mb-1"
                        title="พิมพ์ใบเสร็จ"
                        @click="print_invoice(dataDetail.item.order_code)"
                      >
                        <v-icon>mdi-printer</v-icon>พิมพ์
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-pagination
                v-if="data_list.length !== 0"
                class="mt-4 mb-4"
                v-model="num_pages"
                :length="pages"
                :total-visible="7"
                circle
                color="#8cc63e"
              ></v-pagination>
            </div>
          </div>
        </div>
        <v-dialog v-model="tracking_save" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form ref="update" @submit.prevent="save_data">
              <div class="d-flex justify-space-between">
                <v-card-title> ยืนยันการส่งสินค้า </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  รถสินค้าของคุณ
                  ได้ทำการออกไปจัดส่งสินค้าให้พาร์ทเนอร์เรียบร้อยแล้ว ?
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn
                  large
                  class="rounded-pill grad-success-bg white--text mr-3"
                  type="submit"
                  style="font-size: 18px"
                >
                  ส่งสินค้าแล้ว
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>

        <!-- tracking_shop -->
        <v-dialog v-model="tracking_shop_save" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form ref="update" @submit.prevent="save_data_tracking_shop">
              <div class="d-flex justify-space-between">
                <v-card-title> ยืนยันการส่งสินค้า </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  คุณจัดสินค้าให้ลูกค้าเรียบร้อยแล้ว แจ้งลูกค้ามารับได้เลยใช่ไหม
                  ?
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn
                  large
                  class="rounded-pill grad-success-bg white--text mr-3"
                  type="submit"
                  style="font-size: 18px"
                >
                  จัดสินค้าแล้ว
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- tracking_chiangmai -->
        <v-dialog v-model="tracking_chiangmai_save" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form ref="update" @submit.prevent="save_data_chiangmai">
              <div class="d-flex justify-space-between">
                <v-card-title> ยืนยันการส่งสินค้า </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  รถสินค้าของคุณ ได้ทำการออกไปจัดส่งสินค้าให้ลูกค้าเรียบร้อยแล้ว
                  ?
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn
                  large
                  class="rounded-pill grad-success-bg white--text mr-3"
                  type="submit"
                  style="font-size: 18px"
                >
                  ส่งสินค้าแล้ว
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- tracking_global -->
        <v-dialog v-model="tracking_global_save" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form ref="update" @submit.prevent="save_data_global">
              <div class="d-flex justify-space-between">
                <v-card-title> เพิ่มหมายเลขแทร๊กกิ้ง </v-card-title>
                <v-btn icon class="ma-4" @click="close_modal">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  <v-text-field
                    color="#86bc3a"
                    clearable
                    class="rounded-pill"
                    type="text"
                    label="กรุณากรอกหมายเลขแทร็กกิ้ง"
                    :rules="[(v) => !!v || 'กรุณากรอกหมายเลขแทร็กกิ้ง']"
                    prepend-inner-icon="mdi-truck-minus-outline"
                    v-model="modal_track.tracking_number"
                    hide-details="auto"
                    outlined
                  ></v-text-field>
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn
                  large
                  class="rounded-pill grad-success-bg white--text mr-3"
                  type="submit"
                  style="font-size: 18px"
                >
                  ยืนยันหมายเลขแทร็กกิ้ง
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>

        <!-- Dialog Log การอัพเดท stock -->
        <v-dialog v-model="stock_log_dialog" persistent max-width="900">
          <v-card class="rounded-xl">
            <div class="d-flex justify-space-between align-center pa-4">
              <v-card-title class="pa-0">Log การอัพเดท stock (คำสั่งซื้อ)</v-card-title>
              <v-btn icon @click="stock_log_dialog = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div v-if="loading_stock_logs" class="text-center py-4">
                <v-progress-circular indeterminate color="#86bc3a" size="40"></v-progress-circular>
                <div class="mt-2">กำลังโหลด...</div>
              </div>
              <div v-else>
                <v-btn
                  small
                  class="mb-3"
                  color="#86bc3a"
                  dark
                  @click="fetchStockLogs(stock_log_order_id)"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  Reload รายการ
                </v-btn>
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th>รหัสสินค้า</th>
                      <th>จำนวน</th>
                      <th>stock ก่อน</th>
                      <th>stock หลัง</th>
                      <th>สถานะ</th>
                      <th>ประเภท</th>
                      <th>วันที่</th>
                      <th>จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="log in stock_logs" :key="log.id">
                      <td>{{ log.product_code }}</td>
                      <td>{{ log.quantity }}</td>
                      <td>{{ log.prev_in_stock != null ? log.prev_in_stock : '-' }}</td>
                      <td>{{ log.new_in_stock != null ? log.new_in_stock : '-' }}</td>
                      <td>
                        <span :class="log.status === 'success' ? 'green--text' : 'red--text'">
                          {{ log.status === 'success' ? 'สำเร็จ' : (log.status === 'not_found' ? 'ไม่พบ' : 'ผิดพลาด') }}
                        </span>
                        <span v-if="log.error_message" class="caption d-block grey--text">{{ log.error_message }}</span>
                      </td>
                      <td>{{ log.sync_type === 'auto' ? 'อัตโนมัติ' : 'Reload' }}</td>
                      <td class="caption">{{ formatLogDate(log.synced_at) }}</td>
                      <td>
                        <v-btn
                          v-if="log.status !== 'success'"
                          x-small
                          color="orange"
                          dark
                          :loading="retrying_log_id === log.id"
                          @click="retryStockItem(log)"
                        >
                          Reload
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <div v-if="stock_logs.length === 0 && !loading_stock_logs" class="text-center grey--text py-4">
                  ยังไม่มี log การ sync stock สำหรับคำสั่งซื้อนี้
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- ยืนยันการรีเซ็ต -->
        <v-dialog v-model="clear_reset_lot" persistent max-width="900">
          <v-card class="rounded-xl">
            <v-form @submit.prevent="save_clear_reset_lot">
              <div class="d-flex justify-space-between">
                <v-card-title> ยืนยันการเคลียร์ล็อตสินค้าใหม่ </v-card-title>
                <v-btn icon class="ma-4" @click="clear_reset_lot = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="ma-3 ml-1">
                  คุณต้องการเคลียร์ล็อตสินค้าใหม่หรือไม่ ?
                </div>
              </v-card-text>
              <v-spacer></v-spacer>
              <div class="text-center pa-4">
                <v-btn
                  large
                  class="rounded-pill grad-cancel-bg white--text mr-3"
                  type="submit"
                  style="font-size: 18px"
                >
                  เคลียร์ล็อตสินค้าใหม่
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-dialog>
      </v-card>
      <v-overlay :value="overlay" class="z_index">
        <div style="text-align: center">
          <v-progress-circular
            indeterminate
            size="70"
            width="7"
            color="#86bc3a"
          ></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { formatPrice } from "@/js/handler";
import { HTTP } from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Order_partner_main",
  data() {
    return {
      loading_page: false,
      loading_data: false,
      tracking_save: false,
      alert_success: false,
      alert_tracking: false,
      overlay: false,
      title_type: 1,
      modal_track: {
        tracking_id: null,
        tracking_number: null,
      },
      tracking_shop_save: false,
      tracking_chiangmai_save: false,
      tracking_global_save: false,
      clear_reset_lot: false,
      clear_reset_lot_id: null,
      alert_clear_reset_lot_success: false,
      stock_log_dialog: false,
      stock_log_order_id: null,
      stock_logs: [],
      loading_stock_logs: false,
      retrying_log_id: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        "items-per-page-text": "รายการต่อหน้า",
      },
      headers: [],
      data_list: [],
      tab_menu: 0,
      pages: 1,
      num_pages: 1,
      size: 10,
      search: "",
      searchTimer: null,
    };
  },
  methods: {
    format_price: function (value) {
      return formatPrice(value);
    },
    page(type) {
      this.title_type = type;
      if (this.title_type === 0) {
        this.headers = [
          {
            text: "รหัสคำสั่งซื้อ",
            value: "order_code",
            fixed: true,
            width: "200px",
          },
          {
            text: "เลขใบกำกับภาษี",
            value: "receipt_code",
            fixed: true,
            width: "300px",
          },
          {
            text: "ลูกค้า",
            value: "name",
            fixed: true,
            width: "300px",
          },
          {
            text: "ยอดรวม",
            value: "total",
            fixed: true,
            width: "200px",
          },
          {
            text: "วันที่สั่งซื้อ",
            value: "created_at",
            fixed: true,
            width: "150px",
          },
          {
            text: "สถานะ",
            value: "status",
            fixed: true,
            width: "250px",
          },
          {
            text: "จัดการ",
            value: "",
            sortable: false,
            fixed: true,
            width: "180px",
          },
          {
            text: "พิมพ์",
            value: "",
            sortable: false,
            fixed: true,
            width: "180px",
          },
        ];
        this.get_data();
      }
      if (this.title_type === 1) {
        this.headers = [
          {
            text: "รหัสคำสั่งซื้อ",
            value: "order_code",
            fixed: true,
            width: "200px",
          },
          {
            text: "เลขใบกำกับภาษี",
            value: "receipt_code",
            fixed: true,
            width: "300px",
          },
          {
            text: "ลูกค้า",
            value: "name",
            fixed: true,
            width: "300px",
          },
          {
            text: "ยอดรวม",
            value: "total",
            fixed: true,
            width: "200px",
          },
          {
            text: "วันที่สั่งซื้อ",
            value: "created_at",
            fixed: true,
            width: "150px",
          },
          {
            text: "รายละเอียด",
            value: "",
            sortable: false,
            fixed: true,
            width: "250px",
          },
          {
            text: "จัดการ",
            value: "",
            sortable: false,
            fixed: true,
            width: "180px",
          },
          {
            text: "พิมพ์",
            value: "",
            sortable: false,
            fixed: true,
            width: "180px",
          },
        ];
        this.get_data();
      }
    },
    tracking_modal(id, count_product_not_have_in_warehouse) {
      if (count_product_not_have_in_warehouse == 0) {
        this.tracking_save = true;
        this.modal_track.tracking_id = id;
      }

      if (count_product_not_have_in_warehouse != 0) {
        Swal.fire({
          title: "ไม่สามารถดำเนินการได้ !",
          text: "สินค้าในคลังไม่เพียงพอ กรุณาตรวจสอบคำสั่งซื้อหรือนำสินค้าเข้าคลัง!",
          icon: "error",
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.tracking_save = false;
        });
      }
    },
    get_data() {
      this.loading_data = true;
      HTTP.post(
        `wholesales/allpartner?page=${this.num_pages}&size=${this.size}&search=${this.search}`,
        {
          status: this.title_type,
          user_type: 3,
        }
      ).then((res) => {
        if (res.data.success === true) {
          this.loading_data = false;
          this.data_list = res.data.object;
          this.num_pages = parseInt(res.data.page);
          this.pages = parseInt(res.data.count_pages);
        }
      });
    },
    get_detail(id) {
      this.$router.push("/sell/orderpartnerdetail/" + id);
    },
    openStockLogDialog(order_id) {
      this.stock_log_order_id = order_id;
      this.stock_log_dialog = true;
      this.fetchStockLogs(order_id);
    },
    async fetchStockLogs(order_id) {
      this.loading_stock_logs = true;
      this.stock_logs = [];
      try {
        const res = await HTTP.get("wholesales/stock-sync-logs", {
          params: { order_wholesale_id: order_id },
        });
        if (res.data.success && res.data.object) {
          this.stock_logs = res.data.object;
        }
      } catch (e) {
        console.error(e);
        this.$root.$emit("snackbar", { text: "โหลด log ไม่สำเร็จ", color: "error" });
      } finally {
        this.loading_stock_logs = false;
      }
    },
    formatLogDate(val) {
      if (!val) return "-";
      const d = new Date(val);
      return d.toLocaleString("th-TH");
    },
    async retryStockItem(log) {
      this.retrying_log_id = log.id;
      try {
        const res = await HTTP.post("wholesales/stock-sync-retry-item", {
          log_id: log.id,
        });
        if (res.data.success) {
          this.$root.$emit("snackbar", { text: res.data.message || "อัพเดท stock รายการนี้เรียบร้อย", color: "success" });
          this.fetchStockLogs(this.stock_log_order_id);
        } else {
          this.$root.$emit("snackbar", { text: res.data.message || "ไม่สำเร็จ", color: "error" });
        }
      } catch (e) {
        const msg = e.response?.data?.message || e.message || "เกิดข้อผิดพลาด";
        this.$root.$emit("snackbar", { text: msg, color: "error" });
      } finally {
        this.retrying_log_id = null;
      }
    },
    tracking_shop(id, count_product_not_have_in_warehouse) {
      if (count_product_not_have_in_warehouse == 0) {
        this.tracking_shop_save = true;
        this.modal_track.tracking_id = id;
      }

      if (count_product_not_have_in_warehouse != 0) {
        Swal.fire({
          title: "ไม่สามารถดำเนินการได้ !",
          text: "สินค้าในคลังไม่เพียงพอ กรุณาตรวจสอบคำสั่งซื้อหรือนำสินค้าเข้าคลัง!!!",
          icon: "error",
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.tracking_shop_save = false;
        });
      }
    },
    tracking_chiangmai(id, count_product_not_have_in_warehouse) {
      if (count_product_not_have_in_warehouse == 0) {
        this.tracking_chiangmai_save = true;
        this.modal_track.tracking_id = id;
      }

      if (count_product_not_have_in_warehouse != 0) {
        Swal.fire({
          title: "ไม่สามารถดำเนินการได้ !",
          text: "สินค้าในคลังไม่เพียงพอ กรุณาตรวจสอบคำสั่งซื้อหรือนำสินค้าเข้าคลัง!!",
          icon: "error",
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.tracking_chiangmai_save = false;
        });
      }
    },
    tracking_global(id, count_product_not_have_in_warehouse) {
      if (count_product_not_have_in_warehouse == 0) {
        this.tracking_global_save = true;
        this.modal_track.tracking_id = id;
      }

      if (count_product_not_have_in_warehouse != 0) {
        Swal.fire({
          title: "ไม่สามารถดำเนินการได้ !",
          text: "สินค้าในคลังไม่เพียงพอ กรุณาตรวจสอบคำสั่งซื้อหรือนำสินค้าเข้าคลัง",
          icon: "error",
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then(() => {
          this.tracking_global_save = false;
        });
      }
    },
    clear_reset_lot_modal(id) {
      this.clear_reset_lot = true;
      this.clear_reset_lot_id = id;
    },
    save_clear_reset_lot() {
      this.overlay = true;
      this.clear_reset_lot = false;
      HTTP.post("wholesales/recreate", {
        order_wholesale_id: this.clear_reset_lot_id,
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false;
          this.clear_reset_lot_id = null;
          this.alert_clear_reset_lot_success = true;
          setTimeout(() => (this.alert_clear_reset_lot_success = false), 1000);
          this.get_data();
        }
      });
    },
    async save_data() {
      try {
        this.overlay = true;
        const res = await HTTP.post("wholesales/completepartner", {
          order_id: this.modal_track.tracking_id,
          user_id: this.$store.state.userDetail.id,
          user_name: this.$store.state.userDetail.name,
        });
        
        // รอให้ API เสร็จก่อนปิด overlay
        if (res.data.success === true) {
          // Debug: ดู response structure
          console.log('📦 Response จาก completepartner:', res.data);
          console.log('📦 res.data.object:', res.data.object);
          
          // ตรวจสอบว่าต้องอัพเดท stock หรือไม่
          if (res.data.object?.needs_stock_update === true && res.data.object?.store_id) {
            try {
              // เรียก API updateproductstoreinstock หลังจาก completepartner เสร็จ
              await HTTP.post("wholesales/updateproductstoreinstock", {
                store_id: res.data.object.store_id,
                order_wholesale_id: res.data.object.order_id,
              });
              console.log('✅ อัพเดท stock สำเร็จ');
            } catch (error) {
              console.error("❌ Error ในการอัพเดท stock:", error);
              // แสดง error แต่ไม่หยุดการทำงาน
              Swal.fire({
                title: "คำเตือน",
                text: "อัพเดท stock ไม่สำเร็จ แต่คำสั่งซื้อบันทึกเรียบร้อยแล้ว",
                icon: "warning",
                confirmButtonText: `ตกลง`,
              });
            }
          }
          
          // รอให้ save_data_calculate_product() เสร็จก่อน
          await this.save_data_calculate_product();
          
          // หลังจาก save_data_calculate_product() เสร็จแล้ว ค่อยแสดง Swal และปิด overlay
          let timerInterval;
          Swal.fire({
            title: "เสร็จสิ้น",
            text: "แก้ไขข้อมูลเรียบร้อย",
            icon: "success",
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              timerInterval = setInterval(() => {}, 100);
            },
            willClose: () => {
              clearInterval(timerInterval);
              this.overlay = false;
              this.tracking_success = false;
              this.tracking_save = false;
              this.alert_success = true;
              this.loading_data = false;
              setTimeout(() => (this.alert_success = false), 1000);
              this.get_data();
            },
          });
        } else {
          this.overlay = false;
          Swal.fire({
            title: res.data.message,
            icon: "error",
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.overlay = false;
            this.tracking_success = false;
            this.tracking_save = false;
          });
        }
      } catch (error) {
        this.overlay = false;
        console.error("Error ใน save_data:", error);
        Swal.fire({
          title: "เกิดข้อผิดพลาด",
          text: error.response?.data?.message || error.message || "ไม่สามารถบันทึกข้อมูลได้",
          icon: "error",
          confirmButtonText: `ตกลง`,
        }).then(() => {
          this.tracking_success = false;
          this.tracking_save = false;
        });
      }
    },

    async save_data_calculate_product() {
      try {
        this.loading_data = false;
        const res = await HTTP.get(
          "wholesales/cal-cost-product/" + this.modal_track.tracking_id
        );
        console.log(res.data);
        return res;
      } catch (error) {
        console.error("Error ใน save_data_calculate_product:", error);
        throw error;
      }
    },

    save_data_tracking_shop() {
      HTTP.post("wholesales/trackingnumber", {
        order_id: this.modal_track.tracking_id,
        tracking_number: "รับหน้าร้าน",
        user_id: this.$store.state.userDetail.id,
        user_name: this.$store.state.userDetail.name,
      }).then((res) => {
        if (res.data.success === true) {
          this.tracking_shop_save = false;
          this.alert_success = true;
          setTimeout(() => (this.alert_success = false), 1000);
          this.get_data();
        } else {
          Swal.fire({
            text: res.data.message,
            icon: "error",
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.tracking_shop_save = false;
          });
        }
      });
    },
    save_data_chiangmai() {
      this.overlay = true;
      HTTP.post("wholesales/trackingnumber", {
        order_id: this.modal_track.tracking_id,
        tracking_number: "จัดส่งในเชียงใหม่",
        user_id: this.$store.state.userDetail.id,
        user_name: this.$store.state.userDetail.name,
      }).then((res) => {
        if (res.data.success === true) {
          let timerInterval;
          Swal.fire({
            title: "เสร็จสิ้น",
            text: "แก้ไขข้อมูลเรียบร้อย",
            icon: "success",
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
              timerInterval = setInterval(() => {}, 100);
            },
            willClose: () => {
              clearInterval(timerInterval);
              this.overlay = false;
              this.tracking_shop_save = false;
              this.tracking_chiangmai_save = false;
              this.alert_success = true;
              setTimeout(() => (this.alert_success = false), 1000);
              this.get_data();
            },
          });
        } else {
          Swal.fire({
            text: res.data.message,
            icon: "error",
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.overlay = false;
            this.tracking_shop_save = false;
            this.tracking_chiangmai_save = false;
          });
        }
      });
    },

    save_data_global() {
      if (this.$refs.update.validate()) {
        HTTP.post("wholesales/trackingnumber", {
          order_id: this.modal_track.tracking_id,
          tracking_number: this.modal_track.tracking_number,
          user_id: this.$store.state.userDetail.id,
          user_name: this.$store.state.userDetail.name,
        }).then((res) => {
          if (res.data.success === true) {
            this.tracking_global_save = false;
            this.alert_success = true;
            setTimeout(() => (this.alert_success = false), 1000);
            this.get_data();
          } else {
            Swal.fire({
              text: res.data.message,
              icon: "error",
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then(() => {
              this.tracking_global_save = false;
            });
          }
        });
      }
    },
    close_modal() {
      this.tracking_save = false;
      this.tracking_shop_save = false;
      this.tracking_chiangmai_save = false;
      this.tracking_global_save = false;
      this.modal_track.tracking_number = "";
    },
    change_trackStatus(id) {
      Swal.fire({
        title: "คุณต้องเปลี่ยนสถานะหรือไม่ ?",
        icon: "warning",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          HTTP.post("", {
            id: id,
          }).then((res) => {
            if (res.data.success === true) {
              this.alert_tracking = true;
              setTimeout(() => (this.alert_tracking = false), 2000);
            }
          });
        }
      });
    },
    print_invoice(order_code) {
      window.open(
        "https://www.pharmacare-plus.com/invoicepdfcreditpaywholesale/" +
          order_code,
        "_blank"
      );
      window.open(
        "https://www.pharmacare-plus.com/packingslipwholesale/" + order_code,
        "_blank"
      );
    },
  },
  mounted() {
    this.page(0);
  },
  watch: {
    tab_menu() {
      this.search = "";
      this.num_pages = 1;
      this.page(this.tab_menu);
    },
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.num_pages = 1;
        this.get_data();
      }, 1000);
    },
    num_pages() {
      this.get_data();
    },
  },
};
</script>

<style scoped></style>
